import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from "../../../forBinding";
import { getApiErrorMessage, toApiError } from "../utils";

interface UseDuplicateParcellingParams {
	id: string;
	amount?: number;
}

export const useDuplicateParcelling = () => {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation({
		mutationFn: async ({ id, amount = 1 }: UseDuplicateParcellingParams) => {
			try {
				return (
					await api.post(`/advices/parcelling/duplicate/${id}/${amount}`, undefined, {
						params: { forBinding },
					})
				).data;
			} catch (error) {
				throw toApiError(error, "Erro ao duplicar parcelamento");
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["parcelling"] });
		},
		onError: (error) => {
			console.error("Erro ao duplicar parcelamento:", getApiErrorMessage(error, "Erro ao duplicar parcelamento"));
		},
	});
};
